export default "__VITE_PUBLIC_ASSET__74141999__"